import { BACKDROP } from 'lib/trait';

export const backdropTemplate = {
  type: BACKDROP,
  config: {
    backgroundColor: { light: '#0000004D' },
  },
};
